/* @flow */
import Button from 'components/Button.jsx';
import LayerTrigger from 'components/LayerTrigger.jsx';
import React from 'react';

class MenuButton extends React.Component {
  static propTypes = {
    menu: React.PropTypes.node.isRequired,
    activeClassName: React.PropTypes.string,
    tooltip: React.PropTypes.any,
    tooltipPlacement: React.PropTypes.any,
    tooltipAlignment: React.PropTypes.any,
    disabled: React.PropTypes.bool,
  };

  render() {
    const {
      menu,
      alignment,
      placement,
      activeClassName,
      tooltip,
      tooltipPlacement,
      tooltipAlignment,
      ...other
    } = this.props;

    const button = (
      <Button
        {...other}
        tooltip={tooltip}
        disabled={this.props.disabled}
        tooltipPlacement={tooltipPlacement}
        tooltipAlignment={tooltipAlignment}>
        {this.props.children}
      </Button>
    );

    if (this.props.disabled) {
      return button;
    }

    return (
      <LayerTrigger
        layer={menu}
        trigger="click"
        placement={placement || 'bottom'}
        alignment={alignment || 'left'}
        activeClassName={activeClassName}>
        {button}
      </LayerTrigger>
    );
  }
}

export default MenuButton;



// WEBPACK FOOTER //
// ./src/components/MenuButton.jsx